import { render, staticRenderFns } from "./LocalModelManage.vue?vue&type=template&id=503a64ee&"
import script from "./LocalModelManage.vue?vue&type=script&lang=js&"
export * from "./LocalModelManage.vue?vue&type=script&lang=js&"
import style0 from "./LocalModelManage.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports